//<div id="validation_message_10_23" class="gfield_description validation_message gfield_validation_message">This field is required.</div>

const { $ } = window

export default {
	init() {
    $.each($([135,137,138,143,144,145,146,151,152].map(num => `#field_10_${num} .gfield_list_groups input`).join(",")),function(idx, el){
      el.type="number"
      // el.setAttribute('required',true); //! does not work as sibling field nonnull falsely passes validation
    })
	},
	finalize() {
		// JavaScript to be fired on the services page, after the init JS
	},
}
